export default __webpack_public_path__ + "static/media/Rectangle57.0886036a.png";